export const DefaultAddressSelectionOptionId = 0;
export const AddressSuggestionKey = 'AddressSuggestionOption';
export const MaxNumOfAddressesToShow = 3;
